import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Default from "../../../vendors/components/Layouts/Default";
import React from "react";
import { publicMenuItems } from "../../shared/config/menu/public";
import Login from "../../../vendors/pages/Auth/pages/Login";
import LoginUnico from "../../../vendors/pages/Auth/pages/LoginUnico";
import Logout from "../../../vendors/pages/Auth/pages/Logout";
import { ProgressSpinner } from "primereact/progressspinner";
import { BlockUI } from "primereact/blockui";
import { BlockUIState } from "../../../vendors/redux/@types/blockUI";
import BlockUIService from "../../../vendors/services/blockUIService";
import Portal from "./pages/Portal";
import CompletarCadastro from "./pages/CompletarCadastro";
import EventoVisualizar from "./pages/EventoVisualizar";
import Evento from "./pages/Evento";
import EventoContribuicaoForm from "../DefaultPage/Evento/pages/EventoContribuicaoForm";
import EventoInterno from "./pages/EventoInterno";
import EventoInternoAuth from "./pages/EventoInternoAuth";
import EventoInternoContribuicaoForm from "../DefaultPage/Evento/pages/EventoInternoContribuicaoForm";
import InformesEvento from "../InformesEvento";
import FaleConoscoPage from "../DefaultPage/FaleConosco";
import DuvidasFrequentes from "../DuvidasFrequentes";

export default function PublicPage() {
  const blockUI: BlockUIState = new BlockUIService().getCurrentState();
  const location = useLocation();

  const isEventoInterno =
    location.pathname.startsWith("/evento-interno") ||
    location.pathname.startsWith("/evento-interno-contribuicao") ||
    location.pathname.startsWith("/public/evento/visualizar") ||
    location.pathname.startsWith("/fale-conosco") ||
    location.pathname.startsWith("/eventos") ||
    location.pathname.startsWith("/duvidas-frequentes");

  return (
    <>
      <BlockUI
        blocked={blockUI.blocked}
        template={
          <div className="flex flex-column align-items-center">
            <ProgressSpinner />
            <span
              style={{ color: "white", marginTop: "10px", fontWeight: "bold" }}
            >
              Carregando...
            </span>
          </div>
        }
        autoZIndex={true}
        baseZIndex={6000}
        fullScreen
      >
        <Switch>
          <Route path="/login/unico" component={LoginUnico} />
          <Route path="/evento-interno-auth" component={EventoInternoAuth} />
          <Route path="/login" component={Login} />
          <Route path="/logout" exact={true} component={Logout} />
          <Route path="/completar" exact={true} component={CompletarCadastro} />
          <Default menuItems={publicMenuItems}>
            <Route path="/evento-interno" component={EventoInterno} />
            <Route
              path="/evento-interno-contribuicao"
              exact={true}
              component={EventoInternoContribuicaoForm}
            />
            <Route path="/public" exact={true} component={Portal} />
            <Route path="/informes" exact={true} component={InformesEvento} />
            <Route path="/fale-conosco" component={FaleConoscoPage} />
            <Route
              path="/duvidas-frequentes"
              exact={true}
              component={DuvidasFrequentes}
            />
            <Route
              path="/public/evento/visualizar"
              exact={true}
              component={EventoVisualizar}
            />
            <Route path="/eventos" exact={true} component={Evento} />
            <Route
              path="/evento/contribuicao"
              exact={true}
              component={EventoContribuicaoForm}
            />
            {!isEventoInterno && <Redirect from="*" to="/public" />}
          </Default>
        </Switch>
      </BlockUI>
    </>
  );
}
